import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "heading-title" }, "Additional Information Required", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " For your security, you must validate your identity and authorize this device/computer. We do not recommend authorizing a shared or public computer/device. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Challenge = _resolveComponent("Challenge")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_Challenge)
  ]))
}